import { render, staticRenderFns } from "./ShipmentContentsDisplay.vue?vue&type=template&id=4a91200f&scoped=true&"
import script from "./ShipmentContentsDisplay.vue?vue&type=script&lang=js&"
export * from "./ShipmentContentsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentContentsDisplay.vue?vue&type=style&index=0&id=4a91200f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91200f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a91200f')) {
      api.createRecord('4a91200f', component.options)
    } else {
      api.reload('4a91200f', component.options)
    }
    module.hot.accept("./ShipmentContentsDisplay.vue?vue&type=template&id=4a91200f&scoped=true&", function () {
      api.rerender('4a91200f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/components/ShipmentContentsDisplay.vue"
export default component.exports